// DO NOT EDIT THIS IS AN AUTOGENERATED FILE;
import * as React from 'react'

interface IconProps {
  color?: string
  size?: string | number
}

const SvgSunrise2 = ({color = 'currentColor', size = 20}: IconProps) => (
  <svg
    viewBox="0 0 20 20"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    height={size}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.75 2.75a.75.75 0 0 0-1.5 0v.5a.75.75 0 1 0 1.5 0v-.5ZM8.5 9a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM10 6a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm-7.26 7.5a.75.75 0 0 0 0 1.5h14.51a.75.75 0 0 0 0-1.5H2.74Zm1.25 3.75a.75.75 0 0 1 .75-.75h10.51a.75.75 0 0 1 0 1.5H4.74a.75.75 0 0 1-.75-.75Zm10.96-13.2a.75.75 0 0 1 0 1.06l-.354.354a.75.75 0 0 1-1.06-1.06l.353-.354a.75.75 0 0 1 1.06 0Zm.8 4.2a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 0-1.5h-.5ZM3 9a.75.75 0 0 1 .75-.75h.5a.75.75 0 1 1 0 1.5h-.5A.75.75 0 0 1 3 9Zm3.11-4.95a.75.75 0 0 0-1.06 1.06l.354.354a.75.75 0 0 0 1.06-1.06l-.353-.354Z"
    />
  </svg>
)

export default SvgSunrise2
